import { EventEmitter, Injectable } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { Subscription } from 'rxjs';
import { IGlobalSearchResult } from '@fi-app/components/global-search/global-search';

@Injectable()
export class GlobalSearchService {
    private showGlobalSearch = new EventEmitter<boolean>();

    constructor(private fiBackend: FiBackendService) {}

    GetGlobalSearchResults(globalSearchParameter) {
        return this.fiBackend.fetchDataPost<IGlobalSearchResult[]>(
            'Search/Search/GetGlobalSearchResults',
            globalSearchParameter,
        );
    }

    onShowGlobalSearch(callback: (isShow: boolean) => void): Subscription {
        return this.showGlobalSearch.subscribe(callback);
    }

    raiseShowGlobalSearch(isShow: boolean) {
        this.showGlobalSearch.emit(isShow);
    }
}
